<script>
import {
  authComputed,
  notificationComputed,
  notificationMethods,
} from '@state/helpers'
import appConfig from '@src/app.config'
import { mapGetters } from 'vuex'

export default {
  props: {
    user: {
      type: Object,
      required: false,
      default: () => null,
    },
    isMenuOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {},
      systemTitle: appConfig.title,
      currntTime: 0,
    }
  },
  computed: {
    ...authComputed,
    ...notificationComputed,
    ...mapGetters('auth', ['isAdmin', 'currentUser']),
    userProfile() {
      return this.currentUser ? this.currentUser : {}
    },
  },
  created() {
    this.getNotfications()
  },
  mounted() {},
  methods: {
    ...notificationMethods,
    isProduct(product) {
      let show = false
      if (this.currentUser) {
        this.currentUser.subscriptions.forEach((element) => {
          if (element === product) show = true
        })
      }
      return show
    },
    deleteNotifications() {
      this.removeNotifications()
    },
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    getNewData() {
      this.currntTime = Date.now()
    },
    getTime(lastTime) {
      return this.formatTime(this.currntTime - lastTime)
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
    <div class="container-fluid">
      <!-- LOGO -->
      <a href="/" class="navbar-brand mr-0 mr-md-2 logo">
        <h5 style="color: #fff;" class="d-inline align-middle text-uppercase"
          >Warehouse Management System</h5
        >
        <!-- <span class="logo-lg">
          <img
            src="@assets/images/logo_dark.svg"
            alt="pastgate"
            height="50px"
          />
        </span>
        <span class="logo-sm">
          <img src="@assets/images/logo_dark.svg" alt="pastgate" height="32" />
        </span>-->
      </a>

      <ul
        class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0"
      >
        <li class>
          <button
            class="button-menu-mobile open-left disable-btn mr-0"
            :class="{ open: isMenuOpened }"
            @click="toggleMenu"
          >
            <feather type="menu" class="menu-icon align-middle"></feather>
            <feather type="x" class="close-icon"></feather>
          </button>
        </li>
      </ul>

      <div>
        <b-dropdown
          id="dropdown-3"
          class="m-md-0 pg-dropdown-top-bar"
          variant="outline"
          toggle-class="pg-top-menu-dropdown"
          right
        >
          <template slot="button-content">
            <div class="d-flex">
              <img
                src="@assets/images/users/avatar.png"
                alt="user-image"
                style="background-color: #fff"
                class="avatar-sm align-self-center rounded-circle mr-sm-2 mr-1"
              />
              <h6 style="color: #fff" class="d-flex flex-row">
                <div class="col-10 p-0">
                  <div class="d-none d-sm-flex col-12"
                    >{{ userProfile.firstName }} {{ userProfile.lastName }}</div
                  >
                  <div class="d-none d-sm-flex col-12 text-info"
                    >Credit: {{ userProfile.balance }}</div
                  >
                </div>
                <i class="uil uil-angle-down p-0 m-0"></i>
              </h6>
            </div>
          </template>
          <b-dropdown-text class="d-sm-none d-flex">
            {{ userProfile.firstName }}
            {{ userProfile.lastName }}
          </b-dropdown-text>
          <b-dropdown-item to="/users/me">Profile</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="/logout">
            Logout
            <i class="uil uil-power ml-5 text-danger"></i>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
